import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {NavigationEnd, Router} from "@angular/router";
import {BehaviorSubject} from "rxjs";
import {LoginService} from "@app/login/login.service";
import {PortalUser} from "@app/model/portal-user.model";

@Component({
  selector: 'flex-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent implements OnInit {
  isOpen: boolean = false;
  activeUser: PortalUser;
  isSignedIn: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  active: string = 'news';
  buttons: SubMenuModel[] = [
    {
      label: 'Admin',
      value: 'admin',
      role: 'admin',
    },
    {
      label: 'Dashboard',
      value: 'dashboard',
      role: 'admin',
    },
    {
      label: 'Deployments',
      value: 'deployments',
      role: 'general',
    },
    {
      label: 'Documents',
      value: 'documents',
      role: 'limited',
    },
    {
      label: 'FLEX Academy',
      value: 'flexu',
      role: 'limited',
    },
    {
      label: 'Logs',
      value: 'logs',
      role: 'general',
    },
    {
      label: 'News',
      value: 'news',
      role: 'limited',
    },
    {
      label: 'Tickets',
      value: 'tickets',
      role: 'limited',
    },
  ];

  constructor(private router: Router, public loginService: LoginService) {}

  ngOnInit(): void {
    if (sessionStorage.getItem('activeUser')) {
      this.loginService.activeUser = JSON.parse(sessionStorage.getItem('activeUser'));
    } else {
      this.router.navigate(['/signin']);
    }
    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        this.isSignedIn.next(this.router.url !== '/signin');
        this.active = this.router.url.replace('/', '');
      }
    });
  }

  goTo(url) {
    if (url === 'flexu') {
        window.location.href = `https://flexu.flexcutech.com/?user=${this.loginService.activeUser.username}`;
    } else {
      this.router.navigate([`/${url}`]).then(() => {});
    }
  }
}

export class SubMenuModel {
    label: string;
    value: string;
    role: 'limited' | 'general' | 'admin' | 'superadmin';
}
